module.exports = __webpack_public_path__ + "img/ex-hm.fd5cd92b.png";